import React from "react";
import Navbar from "./Navbar";
import Home from "./Home";
import "./HomePage.scss";

const HomePage = () => {
  return (
    <div className="homepage">
      <Navbar />
      <Home />
    </div>
  );
};

export default HomePage;
